export default "__VITE_ASSET__gpJa7QVN__"